import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  FiPlus, FiCalendar, FiEdit, FiUser,
} from 'react-icons/fi';
import { formatPhoneNumber } from 'react-phone-number-input';

import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import StyledAccordion from '../../../components/Accordion';
import { PageContext } from '../context';
import {
  BookingNavItem, BookingNavText, BookingNavTitle, BookingNavItemContent,
} from '../styles';
import { CallOut } from './ServiceType/styles';

const BookingNav = ({ isExpanded, isFinal }) => {
  const context = useContext(PageContext);
  const {
    goToStep,
    currentStep,
    selectedService,
    formData: {
      firstName, lastName, primaryPhoneNumber, serviceDay, serviceInterval,
    },
  } = context;

  return (
    <StyledAccordion isExpanded={isExpanded} title="My Selections">
      {currentStep > 0 && (
        <BookingNavItem>
          <FiPlus className="icon_start" />
          <BookingNavItemContent>
            <BookingNavTitle>{selectedService.name}</BookingNavTitle>
            <BookingNavText>
              <CallOut>{selectedService.priceCents / 100}</CallOut>
              {' for '}
              <CallOut>{selectedService.durationMinutes}</CallOut>
              {' minutes'}
            </BookingNavText>
          </BookingNavItemContent>

          {!isFinal && (
            <IconButton
              className="icon_end"
              key="Edit"
              aria-label="Edit"
              onClick={() => goToStep(0)}
            >
              <FiEdit />
            </IconButton>
          )}
        </BookingNavItem>
      )}

      {currentStep > 1 && (
        <BookingNavItem>
          <FiCalendar className="icon_start" />
          <BookingNavItemContent>
            <BookingNavTitle>
              {moment(serviceInterval, 'hh:mm:ss').format('LT')}
              {' - '}
              {moment(serviceInterval, 'hh:mm:ss')
                .add(selectedService.durationMinutes, 'm')
                .format('LT')}
              {' - '}
              {`${selectedService.durationMinutes} mins`}
            </BookingNavTitle>
            <BookingNavText>
              <CallOut>{moment(serviceDay).format('dddd, MMMM Do, YYYY')}</CallOut>
            </BookingNavText>
          </BookingNavItemContent>
          {!isFinal && (
            <IconButton
              className="icon_end"
              key="Edit"
              aria-label="Edit"
              onClick={() => goToStep(1)}
            >
              <FiEdit />
            </IconButton>
          )}
        </BookingNavItem>
      )}

      {currentStep > 2 && (
        <BookingNavItem>
          <FiUser className="icon_start" />
          <BookingNavItemContent>
            <BookingNavTitle>{`${firstName} ${lastName}`}</BookingNavTitle>
            <BookingNavText>
              <CallOut>{formatPhoneNumber(primaryPhoneNumber)}</CallOut>
            </BookingNavText>
          </BookingNavItemContent>

          {!isFinal && (
            <IconButton
              className="icon_end"
              key="Edit"
              aria-label="Edit"
              onClick={() => goToStep(2)}
            >
              <FiEdit />
            </IconButton>
          )}
        </BookingNavItem>
      )}

      {currentStep > 3 && (
        <BookingNavItem>
          <FiEdit className="icon_start" />
          <BookingNavItemContent>
            <BookingNavTitle>COVID-19 Questionnaire:</BookingNavTitle>
            <BookingNavText>Completed</BookingNavText>
          </BookingNavItemContent>
        </BookingNavItem>
      )}
    </StyledAccordion>
  );
};

BookingNav.defaultProps = {
  isExpanded: false,
  isFinal: false,
};

BookingNav.propTypes = {
  isExpanded: PropTypes.bool,
  isFinal: PropTypes.bool,
};

export default BookingNav;
